"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MultiSelectGeneralHandler", {
    enumerable: true,
    get: function() {
        return MultiSelectGeneralHandler;
    }
});
const _generic = require("~/db/field-handler/handlers/generic");
let MultiSelectGeneralHandler = class MultiSelectGeneralHandler extends _generic.GenericFieldHandler {
    async verifyFilter(_filter, _column) {
        return {
            isValid: true
        };
    }
};
